(function(){
  'use strict';
  function normal(value){return String(value||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim()}
  var rules=[
    ['ready',/\b(?:para\s+entrar\s+a\s+vivir|list[ao]s?\s+para\s+(?:entrar\s+a\s+vivir|vivir))\b/],
    ['impeccable',/\bimpecables?\b/],
    ['furnished',/\b(?:amueblad[ao]s?|amuablad[ao]s?)\b/],
    ['solar',/\b(?:(?:con\s+)?(?:paneles|placas)\s+solares|fotovoltaic[ao]s?)\b/],
    ['occupied',/\b(?:ocupad[ao]s?|okupad[ao]s?)\b/],
    ['bank',/\b(?:de\s+bancos?|procedentes?\s+de\s+bancos?|propiedad(?:es)?\s+bancari[ao]s?)\b/],
    ['garageunit',/^garajes?\b/],
    ['warehouse',/\b(?:naves?(?:\s+(?:o\s+naves?\s+)?industrial(?:es)?)?)\b/],
    ['business',/\bnegocios?\b/],
    ['social',/\balquiler(?:es)?\s+social(?:es)?\b/],
    ['trade',/\bpermutas?\b/],
    ['renovate',/\b(?:a\s+reformar|para\s+reformar|necesita\s+reforma)\b/],
    ['cheap',/\b(?:barat(?:o|a|os|as)|econom(?:ico|ica|icos|icas))\b/],
    ['sea',/\b(?:vistas?\s+(?:al?\s+)?mar|vistas?\s+al?\s+oceano)\b/],
    ['rustic',/\brustic(?:a|as|o|os)\b/],
    ['coast',/\b(?:costa|coster(?:a|as|o|os)|playa|playas|cerca\s+del\s+mar)\b/],
    ['pool',/\bpiscinas?\b/],
    ['garden',/\b(?:jardin(?:es)?|fincas?)\b/],
    ['terrace',/\bterrazas?\b/],
    ['garage',/\bgarajes?\b/],
    ['lift',/\bascensores?\b/],
    ['storage',/\btrasteros?\b/]
  ];
  var coast=['a coruna','coruna','oleiros','sada','ferrol','arteixo','culleredo','carballo','a laracha','laracha','caion','malpica','corcubion','fisterra','cee','carnota','foz','ribadeo','viveiro','burela','barreiros','vigo','pontevedra','baiona','nigran','o grove','sanxenxo','vilagarcia','marin','redondela','moana','cangas','ribeira','boiro','noia','mugardos','fene','pobra do caraminal','muro','muros'];
  function parse(query){
    var text=normal(query).replace(/[^a-z0-9\s\/]+/g,' ').replace(/\s+/g,' ').trim(),kind='';
    var kinds=[];for(var i=0;i<rules.length;i++){if(rules[i][1].test(text)){kinds.push(rules[i][0]);text=text.replace(rules[i][1],' ').replace(/\s+/g,' ').trim();}}kind=kinds[0]||'';
    return {kind:kind,kinds:kinds,words:text.split(/\s+/).filter(function(word){return word&&!['en','con','de','del','y','el','la','los','las'].includes(word)&&!(kind==='cheap'&&['propiedad','propiedades','inmueble','inmuebles','venta','ventas','alquiler','alquileres','piso','pisos','casa','casas','terreno','terrenos'].includes(word))})};
  }
  function matches(p,parsed){
    var localText=normal(p.locality).split(/\s*[·|,()]\s*/)[0];
    var typeText=normal(p.propertyType);
    var references=normal(p.title).match(/\baa\s*\/\s*[a-z0-9]+\b/g)||[];
    var searchable=localText+' '+typeText+' '+references.join(' ');
    if(!parsed.words.every(function(word){return searchable.includes(word)}))return false;
    var kinds=parsed.kinds||[parsed.kind];return kinds.filter(Boolean).every(function(kind){return featureMatches(p,kind);});
  }
  function featureMatches(p,kind){if(!kind)return true;
    if(kind==='cheap'){
      var price=Number(p.priceCents),limit=p.operation==='alquiler'?55000:10000000;
      return Number.isFinite(price)&&price>0&&price<limit;
    }
    var local=normal(p.locality),tags=normal(p.tags),title=normal(p.title),type=normal(p.propertyType);
    var yes=function(value){return value===true||String(value).toLowerCase()==='true'};
    var dedicated={ready:'ready',furnished:'furnished',solar:'solar',occupied:'occupied',bank:'bank',social:'social',trade:'trade'}[kind];
    if(dedicated){if(p[dedicated]!==null&&p[dedicated]!==undefined&&p[dedicated]!=='')return yes(p[dedicated]);if(kind==='solar')return /paneles solares/.test(normal(p.heating));if(kind==='occupied')return /ocupad|okupad/.test(normal(p.operation));return false;}
    if(kind==='impeccable')return normal(p.state)==='impecable';
    if(kind==='renovate')return /^(?:a reformar|reforma integral|necesita reforma|para reformar)$/.test(normal(p.state));
    if(kind==='garageunit')return /^(?:garaje|garajes|plaza de (?:garaje|aparcamiento))$/.test(type);
    if(kind==='warehouse')return /^(?:nave|nave industrial|naves industrial(?:es)?)$/.test(type);
    if(kind==='business')return /^negocios?$/.test(type);
    if(kind==='rustic')return /\brustic(?:a|as|o|os)\b/.test([tags,title,type].join(' '));
    if(kind==='sea')return yes(p.seaView)||/vistas?\s+(?:al?\s+)?mar/.test([tags,title].join(' '));
    if(kind==='coast')return yes(p.seaView)||/\b(costa|playa|costera|costero)\b/.test(tags)||coast.some(function(name){return local===name||local.startsWith(name+' ')||local.startsWith(name+' (')});
    var flag={pool:'pool',garden:'garden',terrace:'terrace',garage:'garage',lift:'lift',storage:'storage'}[kind];
    return yes(p[flag])||({pool:/piscina/,garden:/jardin|finca/,terrace:/terraza/,garage:/garaje/,lift:/ascensor/,storage:/trastero/})[kind].test(tags);
  }
  function uiMatches(p,params){
    var group=params.get('okhomes_type')||'',type=normal(p.propertyType||p.title);
    var types={houses:/casa|chalet|unifamiliar|adosado|pareado/,flats:/piso|apartamento|atico|duplex|estudio/,land:/terreno|parcela|finca|solar/,commercial:/local|oficina|nave|negocio/,warehouses:/^nave(?: industrial)?$/,businesses:/^negocio$/,garages:/garaje|plaza.*aparcamiento/};
    if(group&&(!types[group]||!types[group].test(type)))return false;
    var condition=params.get('okhomes_condition');if(condition&&!featureMatches(p,condition))return false;
    var price=p.priceCents!=null?Number(p.priceCents)/100:NaN;
    if(!Number.isFinite(price)){var amount=String(p.price||'').match(/[\d.]+(?:,\d+)?/);price=amount?Number(amount[0].replace(/\./g,'').replace(',','.')):NaN;}
    var min=params.get('okhomes_min'),max=params.get('okhomes_max'),rooms=params.get('okhomes_rooms'),baths=params.get('okhomes_baths');
    if(min!==null&&(!Number.isFinite(price)||price<Number(min)))return false;
    if(max!==null&&(!Number.isFinite(price)||price>Number(max)))return false;
    if(rooms&&!(Number(p.rooms)>=Number(rooms)))return false;
    if(baths&&!(Number(p.baths)>=Number(baths)))return false;
    return true;
  }
  function zonePolygon(value){
    if(!Array.isArray(value)||value.length<3||value.length>64)return null;
    if(!value.every(function(p){return Array.isArray(p)&&p.length===2&&p.every(Number.isFinite)&&Math.abs(p[0])<=180&&Math.abs(p[1])<=85;}))return null;
    var area=0;
    for(var i=0;i<value.length;i++){var a=value[i],b=value[(i+1)%value.length];area+=a[0]*b[1]-b[0]*a[1];}
    if(Math.abs(area)<1e-9)return null;
    function side(a,b,c){return (b[0]-a[0])*(c[1]-a[1])-(b[1]-a[1])*(c[0]-a[0]);}
    for(var i=0;i<value.length;i++)for(var j=i+2;j<value.length;j++){
      if(i===0&&j===value.length-1)continue;
      var a=value[i],b=value[(i+1)%value.length],c=value[j],d=value[(j+1)%value.length];
      if(side(a,b,c)*side(a,b,d)<0&&side(c,d,a)*side(c,d,b)<0)return null;
    }
    return value;
  }
  function zoneContains(property,polygon){
    var x=Number(property.lng),y=Number(property.lat),inside=false;
    if(property.lng==null||property.lat==null||!Number.isFinite(x)||!Number.isFinite(y))return false;
    var title=normal(property.title),local=normal(property.locality);
    var corrections=[['oza cesuras','a coruna',-8.2,43.166667],['o corgo','lugo',-7.447082,42.948083],['outeiro rei','lugo',-7.612276,43.102325],['montecubeiro','lugo',-7.326,43.08475],['toques','melide',-7.955694,42.969005]];
    corrections.forEach(function(c){if(title.includes(c[0])&&local===c[1]){x=c[2];y=c[3];}});
    for(var i=0,j=polygon.length-1;i<polygon.length;j=i++){
      var a=polygon[j],b=polygon[i],cross=(x-a[0])*(b[1]-a[1])-(y-a[1])*(b[0]-a[0]);
      if(Math.abs(cross)<1e-10&&x>=Math.min(a[0],b[0])-1e-10&&x<=Math.max(a[0],b[0])+1e-10&&y>=Math.min(a[1],b[1])-1e-10&&y<=Math.max(a[1],b[1])+1e-10)return true;
      if((a[1]>y)!==(b[1]>y)&&x<(b[0]-a[0])*(y-a[1])/(b[1]-a[1])+a[0])inside=!inside;
    }
    return inside;
  }
  window.okhomesQuickSearch={parse:parse,matches:matches,uiMatches:uiMatches,zonePolygon:zonePolygon,zoneContains:zoneContains};
})();

